export const DASHBOARD_COLORS = Object.freeze({
    manual: "#EA580C",
    picked: "#2563EB",
    pendingProgrammed: "#F59E0B",
    inProgress: "#2563EB",
    finished: "#16A34A",
    complete: "#16A34A",
    partial: "#F59E0B",
    total: "#6B7280"
});

export const metricChipSx = (color, active = false) => ({
    color: active ? "#fff" : color,
    bgcolor: active ? color : `${color}14`,
    border: `1px solid ${active ? color : `${color}66`}`,
    fontWeight: 600,
    "&:hover": active ? {bgcolor: color, filter: "brightness(0.9)"} : undefined
});

export const neutralChipSx = (active = false) => ({
    color: active ? "#fff" : "#374151",
    bgcolor: active ? "#0891B2" : "#F3F4F6",
    border: `1px solid ${active ? "#0891B2" : "#D1D5DB"}`,
    fontWeight: 600,
    "&:hover": active ? {bgcolor: "#0891B2", filter: "brightness(0.9)"} : undefined
});
